// frontend/modules/ess-monitoring/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { ErrorBoundary } from '@/shared/components/ErrorBoundary';
import ESSMonitoringDashboardView from './views/ESSMonitoringDashboardView';

export const essMonitoringRoutes: RouteObject[] = [
    {
        path: '/admin/ess-monitoring',
        element: <ESSMonitoringDashboardView />,
        errorElement: <ErrorBoundary />,
    },
];
